/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FinancingInputs */

const cs_enum_financing = /** @type {(inputs: Enum_FinancingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financování`)
};

const en_enum_financing = /** @type {(inputs: Enum_FinancingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financing`)
};

/**
* | output |
* | --- |
* | "Financing" |
*
* @param {Enum_FinancingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_financing = /** @type {((inputs?: Enum_FinancingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FinancingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_financing(inputs)
	return cs_enum_financing(inputs)
});